export default __webpack_public_path__ + "static/countryBackground-9b0c7577615665f23d339e5e03385248.png";